import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';    
import { Observable, Subject } from 'rxjs';
import * as XLSX from 'xlsx';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
@Injectable()
export class FileService {
    constructor() { }
    public exportAsExcelFile(json: any[], excelFileName: string): void {
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
        const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, excelFileName);
    }
    private saveAsExcelFile(buffer: any, fileName: string): void {
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data,fileName + EXCEL_EXTENSION);
    }

    public multipleWorkSheets (json: any[],json1:any[],json2:any[], excelFileName: string): void  {
        /* generate worksheet */
        var todayTime = new Date();
    let currentTimeEpoch = Date.now();
    let date = new Date(currentTimeEpoch);
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var year = date.getFullYear();
const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
const ws1: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json1);
const ws2: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json2);
// const ws2: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json1);
/* generate workbook and add the worksheet */
const wb: XLSX.WorkBook = XLSX.utils.book_new();
XLSX.utils.book_append_sheet(wb, ws, 'DriverDetails');
XLSX.utils.book_append_sheet(wb, ws1, 'AssistantDetails');
XLSX.utils.book_append_sheet(wb, ws2, 'PassengerDetails');

const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
// this.saveAsExcelFile(excelBuffer, excelFileName);

/* save to file */

XLSX.writeFile(wb, "Tracking_Detail_"+ month + "/" + day + "/" + year+".xlsx");
}

alertFilter :Subject<any> = new Subject();
alertFilterSubscription$ = this.alertFilter.asObservable();
streamFilterMessage(data: any) {
  let obj = data;
  this.alertFilter.next(obj);
}

getFilterSubscription(): Observable<any> {
  return this.alertFilterSubscription$;
}


}